import {Hotel} from "model"
import React from "react"

export type HotelBadgeProps = {
  hotel: Hotel,
}

export const HotelBadge = (props: HotelBadgeProps) => {
  return <span className="badge" style={{backgroundColor: `#${props?.hotel?.themeColor}`, color: "white"}}>{props?.hotel?.name}</span>
}